import { useSpring } from 'react-spring'

const useFadeInFromAvobe = (delay: number) => {
  return useSpring({
    delay: delay,
    from: { y: -50, opacity: 0 },
    config: { duration: 400 },
    loop: {
      y: 0,
      opacity: 1,
    },
  })
}

export default useFadeInFromAvobe
